import React from 'react'
import { Link } from 'react-router-dom'

import { useTrackEvent } from '@ztechapps/webui.telemetry'

import { routesDef } from '../../config/routes'

export const LinkToProductItem = ({
  children,
  className,
  _id,
  productCode,
}: {
  children: React.ReactNode
  className?: string
  _id: string
  productCode?: string
}) => {
  const trackEvent = useTrackEvent()

  const onClick = () => {
    trackEvent('Product Link', { category: 'product', action: 'view_details', product_code: productCode })
  }

  return (
    <Link to={routesDef.ProductItemPage.altPath({ _id })} className={className} onClick={onClick}>
      {children}
    </Link>
  )
}
